import CONFIG from '@/config'
import CryptoJS from 'crypto-js'
import { CRYPTO_SECRET_KEY, REGION_HOST } from '@/constant'
import { Modal } from '@arco-design/web-vue'
import { h } from 'vue'
import { apiV1OssFileGetSignaturePost } from '@/api/autoApi/hhxc-business.api'
import axios from 'axios'
import dayjs from 'dayjs'

const { title, titleReverse, titleSeparator } = CONFIG
/**
 * @author maydays
 * @description 设置标题
 * @param pageTitle
 * @returns {string}
 */
export function getPageTitle(pageTitle) {
  let newTitles = []
  if (pageTitle) newTitles.push(pageTitle)
  if (title) newTitles.push(title)
  if (titleReverse) newTitles = newTitles.reverse()
  return newTitles.join(titleSeparator)
}
/**
 * @author maydays
 * @description 获取Localstorage
 * @param value
 * @returns {any}
 */
export function getLocal(key) {
  return localStorage.getItem(key)
}
/**
 * @author maydays
 * @description 设置Localstorage
 * @param key
 */
export function setLocal(key, value) {
  localStorage.setItem(key, value)
}

/**
 * @author maydays
 * @description 清除Localstorage
 * @param key
 */
export function removeLocal(key) {
  localStorage.setItem(key, '')
}

/**
 * @author maydays
 * @description 格式化时间
 * @param time
 * @param cFormat
 * @returns {string|null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  return format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
}

/**
 * @author maydays
 * @description 格式化时间
 * @param time
 * @param option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

/**
 * @author maydays
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
export function paramObj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}')
}

/**
 * @author maydays
 * @description 父子关系的数组转换成树形结构数据
 * @param data
 * @returns {*}
 */
export function translateDataToTree(data) {
  const parent = data.filter(value => value.parentId === 'undefined' || value.parentId == null)
  const children = data.filter(value => value.parentId !== 'undefined' && value.parentId != null)
  const translator = (parent, children) => {
    parent.forEach(parent => {
      children.forEach((current, index) => {
        if (current.parentId === parent.id) {
          const temp = JSON.parse(JSON.stringify(children))
          temp.splice(index, 1)
          translator([current], temp)
          typeof parent.children !== 'undefined' ? parent.children.push(current) : (parent.children = [current])
        }
      })
    })
  }
  translator(parent, children)
  return parent
}

/**
 * @author maydays
 * @description 树形结构数据转换成父子关系的数组
 * @param data
 * @returns {[]}
 */
export function translateTreeToData(data) {
  const result = []
  data.forEach(item => {
    const loop = data => {
      result.push({
        id: data.id,
        name: data.name,
        parentId: data.parentId,
      })
      const child = data.children
      if (child) {
        for (let i = 0; i < child.length; i++) {
          loop(child[i])
        }
      }
    }
    loop(item)
  })
  return result
}

/**
 * @author maydays
 * @description 10位时间戳转换
 * @param time
 * @returns {string}
 */
export function tenBitTimestamp(time) {
  const date = new Date(time * 1000)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '' + m : m
  let d = date.getDate()
  d = d < 10 ? '' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second //组合
}

/**
 * @author maydays
 * @description 13位时间戳转换
 * @param time
 * @returns {string}
 */
export function thirteenBitTimestamp(time) {
  const date = new Date(time / 1)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '' + m : m
  let d = date.getDate()
  d = d < 10 ? '' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second //组合
}

/**
 * @author maydays
 * @description 获取随机id
 * @param length
 * @returns {string}
 */
export function uuid(length = 32) {
  const num = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
  let str = ''
  for (let i = 0; i < length; i++) {
    str += num.charAt(Math.floor(Math.random() * num.length))
  }
  return str
}
export function getUuid() {
  if (typeof crypto === 'object') {
    if (typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID()
    }
    if (typeof crypto.getRandomValues === 'function' && typeof Uint8Array === 'function') {
      const callback = c => {
        const num = Number(c)
        return (num ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (num / 4)))).toString(16)
      }
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, callback)
    }
  }
  let timestamp = new Date().getTime()
  let perforNow = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let random = Math.random() * 16
    if (timestamp > 0) {
      random = (timestamp + random) % 16 | 0
      timestamp = Math.floor(timestamp / 16)
    } else {
      random = (perforNow + random) % 16 | 0
      perforNow = Math.floor(perforNow / 16)
    }
    return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16)
  })
}

/**
 * @author maydays
 * @description m到n的随机数
 * @param m
 * @param n
 * @returns {number}
 */
export function random(m, n) {
  return Math.floor(Math.random() * (m - n) + n)
}

/**
 * @author maydays
 * @description addEventListener
 * @type {function(...[*]=)}
 */
export const on = (function () {
  return function (element, event, handler, useCapture = false) {
    if (element && event && handler) {
      element.addEventListener(event, handler, useCapture)
    }
  }
})()

/**
 * @author maydays
 * @description removeEventListener
 * @type {function(...[*]=)}
 */
export const off = (function () {
  return function (element, event, handler, useCapture = false) {
    if (element && event) {
      element.removeEventListener(event, handler, useCapture)
    }
  }
})()

//多层数组平铺
export const flat = arr => {
  let data = JSON.parse(JSON.stringify(arr))
  let newData = []
  const callback = item => {
    ;(item.children || (item.children = [])).map(v => {
      callback(v)
    })
    delete item.children
    newData.push(item)
  }
  data.map(v => callback(v))
  return newData
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  return JSON.parse(localStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

// 替换亚马逊主图尺寸
export function replaceMainImageSize(imgUrl, size) {
  return imgUrl.replace(/\._(\S+)_\./g, () => {
    return '._SL' + size + '_.'
  })
}

//千分位
export function thousandNum(str) {
  if (!str && str != 0) return
  str = `${str}`
  if (!str) {
    return '--'
  }
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 格式处理数字（千分位, value是格式的数据，num是保留几位小数, round == true为 四舍五入）
export function formatThousand(value, num, round) {
  //flag 判断是否有小数，用于正则处理 (flag == true,有小数)
  let flag = false
  if (!value && value != 0) return
  let str = `${value}`
  if (!str) {
    return '--'
  }
  if (num || num == 0) {
    // 保留几位小数
    str = Number(value).toFixed(Number(num))
  } else if (round) {
    //四舍五入
    str = Math.round(Number(value)) + ''
  } else {
    str = value + ''
  }
  flag = /\.(\d)+/g.test(str)
  return str.replace(new RegExp(`(?!^)(?=(\\d{3})+${flag ? '\\.' : '$'})`, 'g'), ',')
}

/**
 * jumpSiteByRegion 跳转不同的站点
 * region 站点 asin 搜索的asin keyWord 关键词
 */
export const regionSite = {
  us: 'https://www.amazon.com',
  de: 'https://www.amazon.de',
  fr: 'https://www.amazon.fr',
  uk: 'https://www.amazon.co.uk',
  es: 'https://www.amazon.es',
  it: 'https://www.amazon.it',
  ca: 'https://www.amazon.ca',
  jp: 'https://www.amazon.co.jp',
  美国: 'https://www.amazon.com',
  德国: 'https://www.amazon.de',
  法国: 'https://www.amazon.fr',
  英国: 'https://www.amazon.co.uk',
  西班牙: 'https://www.amazon.es',
  意大利: 'https://www.amazon.it',
  加拿大: 'https://www.amazon.ca',
  日本: 'https://www.amazon.co.jp',
}
export const jumpSiteByRegion = value => {
  let prefix = value.asin ? '/dp/' : '/s?k='
  let region = value.region || 'us'
  let text = value.asin || value.keyWord || value.query || ''
  window.open(regionSite[region] + prefix + encodeURIComponent(text))
}

// 对象转url

export const getParams = params => {
  let paramStr = ''
  Object.keys(params).forEach(item => {
    if (paramStr === '') {
      paramStr = `${item}=${params[item]}`
    } else {
      paramStr = `${paramStr}&${item}=${params[item]}`
    }
  })
  return paramStr
}
export function sleep(time) {
  return new Promise(resolve => setTimeout(resolve, time))
}

export const handleDownloadFileTemplate = url => {
  window.open(url, '_blank')
}
export const numberWithZero = number => {
  return number || number === 0 ? number : '--'
}

/**
 * 加密
 * @param {string} str 需要加密的数据
 * @returns
 */
export function encrypt(str) {
  const cryptoKey = CryptoJS.enc.Utf8.parse(CRYPTO_SECRET_KEY)
  const cryptoOption = {
    iv: CryptoJS.enc.Utf8.parse(CRYPTO_SECRET_KEY.substring(0, 16)),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }
  const encryptedStr = CryptoJS.AES.encrypt(str, cryptoKey, cryptoOption).toString()
  return encryptedStr
}

/**
 * 解密
 * @param {string} str 需要解密的数据
 * @returns
 */
export function decrypt(str) {
  const cryptoKey = CryptoJS.enc.Utf8.parse(CRYPTO_SECRET_KEY)
  const cryptoOption = {
    iv: CryptoJS.enc.Utf8.parse(CRYPTO_SECRET_KEY.substring(0, 16)),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }
  const decryptedStr = CryptoJS.AES.decrypt(str, cryptoKey, cryptoOption).toString(CryptoJS.enc.Utf8)
  return decryptedStr
}

export const getCheckedRow = tableRef => {
  const $table = tableRef.value
  if ($table) {
    return $table.getCheckboxRecords()
  } else {
    throw new Error('未找到table实例！')
  }
}
export const MinModal = ({ type = 'warning', title = '提示', content, width = 400, beforeOk }) => {
  const data = {
    title,
    content: Array.isArray(content) ? h('div', content) : content,
    simple: false,
    width: `${width}px`,
    titleAlign: 'start',
    alignCenter: false,
    hideCancel: false,
    onBeforeOk: beforeOk,
  }
  return Modal[type](data)
}

export const toAmz = value => {
  let prefix = value.asin ? '/dp/' : '/s?k='
  let region = value?.region.toLowerCase() || 'us'
  let text = value.asin || value.keyWord || ''
  const suffix = value.asin ? '?th=1&psc=1' : ''
  window.open((REGION_HOST[region] ? REGION_HOST[region] : REGION_HOST['us']) + prefix + encodeURIComponent(text) + suffix)
}

// 上传文件
export const getInputFile = async ({ fileType = '', multiple = false }) => {
  return new Promise(resolve => {
    const input = document.createElement('input')
    input.type = 'file'
    if (fileType) input.accept = fileType
    input.multiple = multiple
    input.click()
    input.onchange = () => {
      resolve(input.files)
    }
  })
}
export const uploadOssV2 = async (file, fileName) => {
  const { name, size } = file
  const res = await apiV1OssFileGetSignaturePost({ fileName: fileName ? fileName : `${dayjs().valueOf()}_${name}`, isAuto: 0 })
  if (res.code === '200') {
    const sign = res.data
    const formData = new FormData()
    formData.append('policy', sign.policy)
    formData.append('key', `uploads/${sign.fileName}`)
    formData.append('signature', sign.signature)
    formData.append('OSSAccessKeyId', sign.accessKeyId)
    formData.append('success_action_status', '200')
    formData.append('file', file)
    const host = `https://${sign.bucket}.oss-cn-shenzhen.aliyuncs.com/`
    const res1 = await axios.post(host, formData)
    if (res1.status === 200) {
      return { name, size, url: `https://${sign.bucket}.oss-cn-shenzhen.aliyuncs.com/uploads/${sign.fileName}` }
    } else {
      await Promise.reject()
    }
  } else {
    await Promise.reject()
  }
}
export const uploadOssCommon = async ({ file, sign }) => {
  const { name, size } = file
  const formData = new FormData()
  formData.append('policy', sign.policy)
  formData.append('key', sign.key)
  formData.append('signature', sign.signature)
  formData.append('OSSAccessKeyId', sign.accessKeyId)
  formData.append('success_action_status', '200')
  formData.append('file', file)
  const host = `https://${sign.bucket}.oss-cn-shenzhen.aliyuncs.com/`
  const res1 = await axios.post(host, formData)
  if (res1.status === 200) {
    return { name, size, key: sign.key, url: `https://${sign.bucket}.oss-cn-shenzhen.aliyuncs.com/${sign.key}` }
  } else {
    await Promise.reject()
  }
}
export const fileToArrayBuffer = file => {
  return new Promise(resolve => {
    let reader = new FileReader()
    reader.onload = function (result) {
      resolve(result.target.result)
    }
    reader.readAsArrayBuffer(file)
  })
}
// 递归删除空 children 字段
export const delTreeField = (treeData = [], field = 'children') => {
  treeData.map(item => {
    if (item[field]?.length) {
      delTreeField(item[field])
    } else {
      delete item[field]
    }
  })
}
export const generateMonthsUntilNow = (startMonth = 1) => {
  const currentMonth = dayjs().month() + 1 // 当前月份（1-12）
  const year = dayjs().year() // 当前年份
  const months = []

  for (let i = startMonth; i <= currentMonth; i++) {
    const month = i < 10 ? `0${i}` : `${i}` // 补零
    months.push(`${year}-${month}`)
  }

  return months
}
export const generateYearsUntilNow = (num = 0) => {
  const currentYear = dayjs().year() // 当前年份
  const years = []

  for (let i = 0; i <= num; i++) {
    years.unshift(`${currentYear - i}`)
  }

  return years
}
export const generateQuartersUntilNow = () => {
  const currentQuarter = Math.ceil((dayjs().month() + 1) / 3) // 当前季度（1-4）
  const year = dayjs().year() // 当前年份
  const quarters = []

  for (let i = 1; i <= currentQuarter; i++) {
    quarters.push(`${year}-Q${i}`)
  }

  return quarters
}
export const createDateList = (dateType, arg) => {
  if (dateType === 'mt') {
    return generateMonthsUntilNow(arg ? arg : 1)
  } else if (dateType === 'yt') {
    return generateYearsUntilNow()
  } else {
    return generateQuartersUntilNow()
  }
}

export const roundToDecimal = (num, n) => {
  const factor = Math.pow(10, n)
  return Math.round(num * factor) / factor
}

export const assignExisting = (target, ...sources) => {
  const targetKeys = Object.keys(target)
  for (const source of sources) {
    const filteredSource = Object.fromEntries(Object.entries(source).filter(([key]) => targetKeys.includes(key)))
    Object.assign(target, filteredSource)
  }
  return target
}
